import * as z from 'zod';

/**
 * Order note domain (`GET/POST /admin/notes`). A note is attached to an order;
 * the list-row "last note" column and the notes dialog both read this shape.
 */
export const orderNoteSchema = z
  .object({
    id: z.union([z.string(), z.number()]),
    text: z.string().nullish(),
    created_at: z.string().nullish(),
    created_by_name: z.string().nullish(),
  })
  .loose();
export type OrderNote = z.infer<typeof orderNoteSchema>;

/** Body for creating a note. `type: 'cencel'` is a backend literal (the
 *  misspelling is intentional — the server matches on it). */
export const createOrderNoteSchema = z.object({
  order_id: z.union([z.string(), z.number()]),
  text: z.string().min(1),
  type: z.literal('cencel').default('cencel'),
});
export type CreateOrderNoteInput = z.infer<typeof createOrderNoteSchema>;
